"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfMatchmDoc = instanceOfMatchmDoc;
exports.MatchmDocFromJSON = MatchmDocFromJSON;
exports.MatchmDocFromJSONTyped = MatchmDocFromJSONTyped;
exports.MatchmDocToJSON = MatchmDocToJSON;
exports.MatchmDocToJSONTyped = MatchmDocToJSONTyped;
var OpenOrClosed_1 = require("./OpenOrClosed");
/**
 * Check if a given object implements the MatchmDoc interface.
 */
function instanceOfMatchmDoc(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('state' in value) || value['state'] === undefined)
        return false;
    if (!('initialDelaySeconds' in value) || value['initialDelaySeconds'] === undefined)
        return false;
    if (!('fixedDelaySeconds' in value) || value['fixedDelaySeconds'] === undefined)
        return false;
    if (!('matchUpSize' in value) || value['matchUpSize'] === undefined)
        return false;
    if (!('rematchAllowance' in value) || value['rematchAllowance'] === undefined)
        return false;
    if (!('searchOnEnter' in value) || value['searchOnEnter'] === undefined)
        return false;
    if (!('skipEntrySync' in value) || value['skipEntrySync'] === undefined)
        return false;
    if (!('milliRatingGapMax' in value) || value['milliRatingGapMax'] === undefined)
        return false;
    if (!('milliRatingExpandPerSec' in value) || value['milliRatingExpandPerSec'] === undefined)
        return false;
    if (!('initialMilliRating' in value) || value['initialMilliRating'] === undefined)
        return false;
    if (!('tags' in value) || value['tags'] === undefined)
        return false;
    if (!('webhooks' in value) || value['webhooks'] === undefined)
        return false;
    if (!('kvalBoost' in value) || value['kvalBoost'] === undefined)
        return false;
    if (!('dateCreated' in value) || value['dateCreated'] === undefined)
        return false;
    return true;
}
function MatchmDocFromJSON(json) {
    return MatchmDocFromJSONTyped(json, false);
}
function MatchmDocFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'key': json['key'] == null ? undefined : json['key'],
        'state': (0, OpenOrClosed_1.OpenOrClosedFromJSON)(json['state']),
        'initialDelaySeconds': json['initialDelaySeconds'],
        'fixedDelaySeconds': json['fixedDelaySeconds'],
        'matchUpSize': json['matchUpSize'],
        'rematchAllowance': json['rematchAllowance'],
        'searchOnEnter': json['searchOnEnter'],
        'skipEntrySync': json['skipEntrySync'],
        'milliRatingGapMax': json['milliRatingGapMax'],
        'milliRatingExpandPerSec': json['milliRatingExpandPerSec'],
        'initialMilliRating': json['initialMilliRating'],
        'tags': json['tags'],
        'webhooks': json['webhooks'],
        'kvalBoost': json['kvalBoost'],
        'dateCheckedOut': json['dateCheckedOut'] == null ? undefined : (new Date(json['dateCheckedOut'])),
        'dateCreated': (new Date(json['dateCreated'])),
    };
}
function MatchmDocToJSON(json) {
    return MatchmDocToJSONTyped(json, false);
}
function MatchmDocToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'key': value['key'],
        'state': (0, OpenOrClosed_1.OpenOrClosedToJSON)(value['state']),
        'initialDelaySeconds': value['initialDelaySeconds'],
        'fixedDelaySeconds': value['fixedDelaySeconds'],
        'matchUpSize': value['matchUpSize'],
        'rematchAllowance': value['rematchAllowance'],
        'searchOnEnter': value['searchOnEnter'],
        'skipEntrySync': value['skipEntrySync'],
        'milliRatingGapMax': value['milliRatingGapMax'],
        'milliRatingExpandPerSec': value['milliRatingExpandPerSec'],
        'initialMilliRating': value['initialMilliRating'],
        'tags': value['tags'],
        'webhooks': value['webhooks'],
        'kvalBoost': value['kvalBoost'],
        'dateCheckedOut': value['dateCheckedOut'] == null ? undefined : ((value['dateCheckedOut']).toISOString()),
        'dateCreated': ((value['dateCreated']).toISOString()),
    };
}
